import { useState } from "react";
import { GetStockInward, GetStockSummary, GetStockOutward, GetStockInwardAndOutward } from "../../services/warehouseService";

const useWarehouseDashboard = () => {
    const [totalStock, setTotalStock] = useState([]);
    const [inwardShipment, setInwardShipment] = useState([]);
    const [outwardShipment, setOutwardShipment] = useState([]);
    const [inwardAndOutwardShipment, setInwardAndOutwardShipment] = useState([]);
    const [spaceUtilization, setSpaceUtilization] = useState([]);
    const [kpiData, setKpiData] = useState([]);
    const [inventoryCategory, setInventoryCategory] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchDashBoardTopDetails = async () => {
        const params = {
            p_company_id: localStorage.getItem("companyid"),
            p_plant_id: 1,
            p_period_type:'year',
        };

        setLoading(true);
        setError(null);

        try {
            const [stockSummaryData, inwardData, outwardData, inwardAndOutwardData] = await Promise.all([
                GetStockSummary(params),
                GetStockInward(params),
                GetStockOutward(params),
                GetStockInwardAndOutward(params),
            ]);

            setTotalStock(stockSummaryData || []);
            setInwardShipment(inwardData || []);
            setOutwardShipment(outwardData || []);
            setInwardAndOutwardShipment(inwardAndOutwardData||[]);

            // ✅ Calculate sum of all total_weight values
            const sum_of_total_qty = stockSummaryData.reduce(
                (sum, e) => sum + (Number(e.total_weight) || 0),
                0
            );

            const sum_of_total_inward_count = inwardData.reduce(
                (sum, e) => sum + (Number(e.total_inward_count) || 0),
                0
            );

            const sum_of_total_outward_count = outwardData.reduce(
                (sum, e) => sum + (Number(e.total_outward_count) || 0),
                0
            );

            // formating process            

            const summaryData = [
                { title: "Total Warehouses", value: stockSummaryData?.length || 0 },
                { title: "Total Stock (MT)", value: sum_of_total_qty },
                { title: "Inward Shipments (Today)", value: sum_of_total_inward_count },
                { title: "Outward Shipments (Today)", value: sum_of_total_outward_count },
                { title: "Space Utilization", value: "82%" },
            ];

            setKpiData(summaryData);

            //product wise sum
            const sum_of_reel_inward = inwardData.reduce(
                (sum, e) => sum + (Number(e.reel_inward_count) || 0),
                0
            );
            
            // bundle            
            const sum_of_bundle_inward = inwardData.reduce(
                (sum, e) => sum + (Number(e.bundle_inward_count) || 0),
                0
            );

            // ream pallet
             const sum_of_ream_pallet_inward = inwardData.reduce(
                (sum, e) => sum + (Number(e.ream_pallet_inward_count) || 0),
                0
            );

            const summaryInventoryCategory = [
                { id: "Reel", label: "Reel", value: sum_of_reel_inward },
                { id: "Bundle", label: "Bundle", value: sum_of_bundle_inward },
                { id: "ReamPallet", label: "ReamPallet", value: sum_of_ream_pallet_inward },
                // { id: "Consumables", label: "Consumables", value: 25 },
            ];

            setInventoryCategory(summaryInventoryCategory);


        } catch (err) {
            console.error("Error fetching warehouse dashboard data:", err);
            setError("Failed to load dashboard data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return {
        totalStock,
        inwardShipment,
        outwardShipment,
        spaceUtilization,
        loading,
        error,
        kpiData,
        inventoryCategory,
        inwardAndOutwardShipment,
        fetchDashBoardTopDetails,
    };
};

export default useWarehouseDashboard;
